import { accentBaseColor } from '@adaptive-web/adaptive-ui/reference';
import { FASTElement, attr, customElement } from '@microsoft/fast-element';
import template from './template.js';
import styles from './styles.js';

@customElement({
	name: 'site-text',
	template,
	styles
})
export class Text extends FASTElement {
	@attr
	public color!: string;
	protected colorChanged(_previous: string, next: string): void {
		if (next) {
			accentBaseColor.setValueFor(this, next);
		} else {
			accentBaseColor.deleteValueFor(this);
		}
	}
}